import "moment/locale/es";

import { Element, ElementDetails } from "../my-appointments.types";

import moment from "moment";
import { textToFirstUppercase } from "../../../../utils/textToFirstUppercase";

const createDetails = (item, idx): ElementDetails[] => [
  {
    id: idx + "1",
    text: item.professional.split("_")[0],
    help: item.professional.split("_")[1],
    icon: "🩺",
    featured: true,
  },
  {
    id: idx + "2",
    text: item.start_time
      ? textToFirstUppercase(
          moment(item.start_time)
            .locale("es")
            .format("dddd, DD [de] MMMM [de] YYYY | h:mm a")
        )
      : "Sin fecha programada",
    icon: "📅",
  },
  {
    id: idx + "3",
    text: textToFirstUppercase(item.place),
    icon: "🌎",
  },
];

export const myAppointmentsAdapter = (data: any) => {
  const process: Element[] = data.map((item, idx) => ({
    id: item.id,
    title: textToFirstUppercase(item.service),
    details: createDetails(item, idx),
  }));

  return process;
};
